module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.2c4ac2d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Light.woff2
// module id = ZlbI
// module chunks = 0